import { useIntl } from "react-intl";
import { getDaysUntilExpiration, isExpiringSoon } from "./assetHelpers.ts";
import styles from "./ExpiringSoonMessage.module.scss";
import { clsx } from "clsx";
import { License } from "../../api/decimal/common-types/manageAssets.ts";

export default function ExpiringSoonMessage({
  license,
  className,
}: {
  license: License;
  className?: string;
}) {
  const intl = useIntl();

  if (!isExpiringSoon(license)) {
    return null;
  }

  function getMessage() {
    if (getDaysUntilExpiration(license) === 0) {
      return intl.formatMessage({
        defaultMessage: "Expires in less than 1 day",
      });
    }
    return intl.formatMessage(
      {
        defaultMessage: "Expires on {expirationDate, date, mm/dd/yyyy}",
      },
      { expirationDate: new Date(license.expiresAt) }
    );
  }

  return (
    <div className={clsx(className, styles.container)}>{getMessage()}</div>
  );
}
